module.exports = __webpack_public_path__ + "cb56dc36988148a681e89a1d39842167.png";